import React from 'react';
import Balancer from 'react-wrap-balancer';

export const BalancedText: React.FC = ({ children }) => {
  // Unit test text assertions fail if the text is split into multiple lines.
  if (process.env.NODE_ENV === 'test') {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <>{children}</>;
  }

  return <Balancer>{children}</Balancer>;
};
